var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2726",
    "data-name": "Group 2726",
    transform: "translate(-13055 -392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "noun-bold-4928509",
    d: "M186.668,46.668h5.492a4.027,4.027,0,0,1,3.077,6.625,4.211,4.211,0,0,1-1.8,8.019h-6.773ZM188.5,48.5h3.661a2.2,2.2,0,0,1,0,4.393H188.5Zm0,6.224v4.76h4.943a2.38,2.38,0,0,0,0-4.759Z",
    transform: "translate(12875.082 349.999)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_892",
    "data-name": "Rectangle 892",
    width: 24,
    height: 24,
    transform: "translate(13055 392)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/bold.fd54a52796ddfe0eb714472f88d4b2a8.svg";
export { ForwardRef as ReactComponent };